import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

import ApplicationController from './application_controller';

/**
 * Experience media gallery lightbox (PhotoSwipe v5).
 *
 * v5 builds its own dialog DOM and handles the accessibility for us: it moves
 * focus into the lightbox on open, traps Tab, closes on Escape, returns focus to
 * the trigger thumbnail on close, and its controls carry ARIA roles/names. We just
 * feed it the slide data from the existing `.gallery-item` anchors (full image in
 * `href`, dimensions in `data-size="WxH"`).
 */
export default class extends ApplicationController {
  static targets = ['image'];

  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: '.gallery-item',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      loop: true,
    });

    this.lightbox.addFilter('domItemData', (itemData, element) => {
      const [w, h] = (element.getAttribute('data-size') || '800x600').split('x').map(Number);
      const img = element.querySelector('img');
      itemData.src = element.getAttribute('href');
      itemData.width = w || 800;
      itemData.height = h || 600;
      itemData.msrc = img ? img.getAttribute('src') : undefined;
      itemData.alt = img ? img.getAttribute('alt') || '' : '';
      return itemData;
    });

    this.lightbox.init();
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }
}
